import { ChartsProps } from '../Charts'
import { RenderCharts } from '../RenderCharts'
import html2canvas from 'html2canvas'
import { imageSizeProperties } from './imageSizes'
import { ImageBase64 } from '../../api/utils/types'
import { cropBase64Image } from '../../api/image/crop'
import { ImageSizeToArrayPx } from './ImageSizeToArrayPx'
import { ImageSize } from './types'

export async function renderImagesDashboard(chartsProps: ChartsProps): Promise<[ImageSize, ImageBase64[]]> {
    const containerPart = await RenderCharts(chartsProps)
    const dashboardPartDiv = containerPart.querySelector('.render-pdf-chart-container') as HTMLElement

    const rectDashboardPart = dashboardPartDiv.getBoundingClientRect()

    const dashboardPartCanvas = await html2canvas(dashboardPartDiv, {
        useCORS: true,
        imageTimeout: 30000,
        height: rectDashboardPart.height,
        width: rectDashboardPart.width,
        scale: 1
    })

    const dashboardPartURL = dashboardPartCanvas.toDataURL('image/png')

    const dashboardPartSize = imageSizeProperties({
        bodyHeightIn: Math.max(chartsProps.cropItem.ticksDepth, chartsProps.cropItem.ticksTime),
        headerHeightPx: chartsProps.heightHeaderPx,
        heightPx: rectDashboardPart.height,
        widthPx: rectDashboardPart.width,
        widthIn: chartsProps.widthIn
    })
    
    const imagesDashboardPart = (await cropBase64Image(dashboardPartURL, ImageSizeToArrayPx(dashboardPartSize)))?.images

    dashboardPartDiv.remove()
    dashboardPartCanvas.remove()

    return [dashboardPartSize, imagesDashboardPart]
}
